export const tl = (_rc='', _url='', _app='')=>{
    return {
        "key": "tl",
        "url": _url? _url: `https://${_rc}tl.plaync.com`,
        "app": _app? _app: "pc"
    };
}

export const lineagew = (_rc='', _url='', _app='')=>{
    return {
        "key": "lineagew",
        "url": _url? _url: `https://${_rc}lineagew.plaync.com`,
        "app": _app? _app: "pc,apple,android"
    };
}

export const bns2 = (_rc='', _url='', _app='')=>{
    return {
        "key": "bns2",
        "url": _url? _url: `https://${_rc}bns2.plaync.com`,
        "app": _app? _app: "pc,apple,android"
    };
}

export const tricksterm = (_rc='', _url='', _app='')=>{
    return {
        "key": "tricksterm",
        "url": _url? _url: `https://${_rc}tricksterm.plaync.com`,
        "app": _app? _app: "pc,apple,android"
    };
}

export const h3 = (_rc='', _url='', _app='')=>{
    return {
        "key": "h3",
        "url": _url? _url: `https://${_rc}h3.plaync.com`,
        "app": _app? _app: "pc,apple,android"
    };
}

export const lineage2m = (_rc='', _url='', _app='')=>{
    return {
        "key": "lineage2m",
        "url": _url? _url: `https://${_rc}lineage2m.plaync.com`,
        "app": _app? _app: "pc,apple,android"
    };
}

export const lineage2mNaeu = (_rc='', _url='', _app='')=>{
    return {
        "key": "lineage2m",
        "url": _url? _url: `https://${_rc}lineage2m.plaync.com/naeu`,
        "app": _app? _app: "pc,apple,android"
    };
}

export const lineage2mRu = (_rc='', _url='', _app='')=>{
    return {
        "key": "lineage2m",
        "url": _url? _url: `https://${_rc}lineage2m.plaync.com/ru`,
        "app": _app? _app: "pc,apple,android"
    };
}

export const lineagem = (_rc='', _url='', _app='')=>{
    return {
        "key": "lineagem",
        "url": _url? _url: `https://${_rc}lineagem.plaync.com`,
        "app": _app? _app: "pc,apple,android"
    };
}

export const h2 = (_rc='', _url='', _app='')=>{
    return {
        "key": "h2",
        "url": _url? _url: `https://${_rc}h2.plaync.com`,
        "app": _app? _app: "apple,android"
    };
}

export const bns = (_rc='', _url='', _app='')=>{
    return {
        "key": "bns",
        "url": _url? _url: `https://${_rc}bns.plaync.com`,
        "app": _app? _app: "pc"
    };
}

export const aion = (_rc='', _url='', _app='')=>{
    return {
        "key": "aion",
        "url": _url? _url: `https://${_rc}aion.plaync.com`,
        "app": _app? _app: "pc"
    };
}

export const lovebeat = (_rc='', _url='', _app='')=>{
    return {
        "key": "lovebeat",
        "url": _url? _url: `https://${_rc}lovebeat.plaync.com`,
        "app": _app? _app: "pc"
    };
}

export const lineage2 = (_rc='', _url='', _app='')=>{
    return {
        "key": "lineage2",
        "url": _url? _url: `https://${_rc}lineage2.plaync.com`,
        "app": _app? _app: "pc"
    };
}

export const lineage = (_rc='', _url='', _app='')=>{
    return {
        "key": "lineage",
        "url": _url? _url: `https://${_rc}lineage.plaync.com`,
        "app": _app? _app: "pc"
    };
}
